import * as yup from 'yup';

export const addFolderSchema = yup.object({
  folderName: yup.string().required('Folder name is required'),
  // users: yup.array().min(1, 'Select at least one user').required('Select at least one user'),
});
